import {getAppointmentClinicName} from '../getAppointmentClinicName';
import {ConfirmationBookedAppointmentParams} from './types';

export const confirmationBookedAppointment = ({
	bookingNumber,
	appointments,
	isAdvanceDiagnosticsExamsJourneyEnabled = false,
}: ConfirmationBookedAppointmentParams) => {
	if (appointments.length === 0 || !bookingNumber) {
		return null;
	}

	const booked = appointments.find(
		item => item.bookingNumber.toString() === bookingNumber.toString(),
	);

	if (!booked) {
		return null;
	}

	return {
		...booked,
		clinicName: getAppointmentClinicName({
			appointment: booked,
			isAdvanceDiagnosticsExamsJourneyEnabled,
		}),
	};
};
